import authStore from './auth/store.js'

import App from './components/app.svelte'


if ('serviceWorker' in navigator) {
  // TODO: Drop once old service worker has been removed from all clients.
  // Remove the old service worker on the root.
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      if (!registration.scope.endsWith('/app/')) {
        registration.unregister()
      }
    }
  })
  navigator.serviceWorker.register('/app/sw.js')
}

authStore.requireAuth(() => {
  new App({
    target: document.body,
  })
})
